export default "__VITE_ASSET__Bjiy8B9G__"